import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { TimePicker } from '@atlaskit/datetime-picker';
import { fg } from '@atlaskit/platform-feature-flags';
import { DEFAULT_LOCALE } from '../../../../intl-provider/ProFormaIntlProvider';
import { times } from '../common/dayTimes';
import { ShortFieldWrapper } from '../common/questionWrappers';
import { EditTimeMessages, IntlEditTimeMessages } from './EditTimeMessages.intl';
export var EditTime = function EditTime(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    value = _ref.value,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    onChange = _ref.onChange,
    label = _ref.label;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(ShortFieldWrapper, null, /*#__PURE__*/React.createElement(TimePicker, _extends({
    id: id,
    times: times,
    value: value,
    isInvalid: isInvalid,
    isRequired: isRequired,
    onChange: onChange,
    locale: intl.locale || DEFAULT_LOCALE,
    timeIsEditable: true,
    placeholder: intl.formatMessage(IntlEditTimeMessages[EditTimeMessages.TimePlaceholder], {
      time: intl.formatTime(new Date(), {})
    }),
    label: label
  }, isInvalid && errorId && fg('jsm-accessibility-fixes') ? {
    'aria-describedby': errorId
  } : {})));
};